import { createSelector } from '@reduxjs/toolkit';

const allSectors = (state) => state.projectState.allSectors;

const allSectorsId = createSelector(allSectors, (allSectors) =>
  allSectors.map((sector) => sector.id)
);

export { allSectorsId };
